/* @flow weak */
import { Record, Map } from 'immutable'
import { logger } from 'logger'
import {
  SIGNIN_START,
  SIGNIN_SUCCESS,
  SIGNIN_ERROR,
  REQUEST_RESET_PASSWORD_START,
  REQUEST_RESET_PASSWORD_SUCCESS,
  REQUEST_RESET_PASSWORD_ERROR,
  RESET_PASSWORD_START,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  TOKEN_RENEWAL_START,
  TOKEN_RENEWAL_SUCCESS,
  TOKEN_RENEWAL_ERROR,
} from './actionTypes'

import { BOOTSTRAP_SUCCESS, BOOTSTRAP_ERROR } from 'data/app/actions'
import { SendReconciliationSSOEmailStatus } from './SendReconciliationSSOEmailStatus'

const State = Record(
  {
    formDisabled: false,
    error: null,
    success: null, // To get accessToken, refreshToken, whatever.
    tokens: null,
    renewalStarted: false,
    renewalSuccess: false,
    renewalError: null,
    sendReconciliationSSOEmailStatuses: Map(),
  },
  'auth'
)

const authReducer = (state = new State(), action) => {
  const { type, payload } = action

  switch (type) {
    case SIGNIN_START:
    case REQUEST_RESET_PASSWORD_START:
    case RESET_PASSWORD_START: {
      return state
        .set('error', null)
        .set('tokens', null)
        .set('formDisabled', true)
    }

    case SIGNIN_ERROR:
    case REQUEST_RESET_PASSWORD_ERROR:
    case RESET_PASSWORD_ERROR: {
      return state
        .set('formDisabled', false)
        .set('success', null)
        .set('error', action.payload)
    }

    case BOOTSTRAP_SUCCESS: {
      const { authentified } = payload
      if (authentified) {
        if (!action.payload || !action.payload.tokens) {
          logger.warn(`Empty payload for BOOTSTRAP_SUCCESS. Aborting.`, action)
          return state
        }
        return state.set('tokens', action.payload.tokens)
      }
      return state
    }
    case BOOTSTRAP_ERROR: {
      return state.set('error', action.payload)
    }
    case SIGNIN_SUCCESS: {
      if (!action.payload || !action.payload.tokens) {
        logger.warn(`Empty payload for SIGNIN_SUCCESS. Aborting.`, action)
        return state
      }
      return state
        .set('formDisabled', false)
        .set('error', null)
        .set('tokens', action.payload.tokens)
        .set('success', action.payload)
    }
    case TOKEN_RENEWAL_START: {
      return state
        .set('renewalError', null)
        .set('renewalSuccess', true)
        .set('renewalStarted', true)
    }
    case TOKEN_RENEWAL_SUCCESS: {
      if (!action.payload || !action.payload.tokens) {
        logger.warn(
          `Empty payload for TOKEN_RENEWAL_SUCCESS. Aborting.`,
          action
        )
        return state
      }
      return state
        .set('renewalSuccess', true)
        .set('renewalStarted', false)
        .set('tokens', action.payload.tokens)
        .set('success', action.payload)
    }
    case TOKEN_RENEWAL_ERROR: {
      return state
        .set('renewalStarted', false)
        .set('renewalError', action.payload)
        .set('success', null)
    }

    case REQUEST_RESET_PASSWORD_SUCCESS:
    case RESET_PASSWORD_SUCCESS: {
      return state
        .set('formDisabled', false)
        .set('error', null)
        .set('success', action.payload)
    }
    case 'SEND_RECONCILIATION_SSO_EMAIL_START': {
      const { variables } = action.meta.action
      return state.updateIn(
        ['sendReconciliationSSOEmailStatuses', variables.userId],
        () => new SendReconciliationSSOEmailStatus({ ongoing: true })
      )
    }
    case 'SEND_RECONCILIATION_SSO_EMAIL_SUCCESS': {
      const { variables } = action.meta.action
      return state.updateIn(
        ['sendReconciliationSSOEmailStatuses', variables.userId],
        () =>
          new SendReconciliationSSOEmailStatus({
            ongoing: false,
            success: true,
          })
      )
    }
    case 'SEND_RECONCILIATION_SSO_EMAIL_ERROR': {
      const { variables } = action.meta.action
      return state.updateIn(
        ['sendReconciliationSSOEmailStatuses', variables.userId],
        () =>
          new SendReconciliationSSOEmailStatus({ ongoing: false, error: true })
      )
    }
    default:
      return state
  }
}

export default authReducer
